import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDatabase, ref, set as FirebaseSet, onValue, push as FirebasePush, get, remove as FirebaseRemove} from 'firebase/database';
import { convertGenEd } from './Search';
import searchData from './data/search.json';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import _ from 'lodash';

export default function Detail(props) {
    const params = useParams();
    var plans = props.plans;
    const setPlan = props.setPlan;
    const username = props.username;
    const courseCode = params.courseDetail;
    const db = getDatabase();

    const currentClass = searchData[courseCode];
    var introContent = (<p>"Not Available"</p>); 

    //---Use this if read from online dataset--//

    // const db = getDatabase();
    // const [currentClass, setClass] = useState(null);
    // const courseRef = ref(db, "detailedInfo/" + params.courseDetail);
    // get(courseRef).then((snapshot) => {
    //     if (snapshot.exists()) {
    //       setClass(snapshot.val());
    //     } else {
    //       console.log("No data available");
    //     }
    //   }).catch((error) => {
    //     console.error(error);
    // });

    const changeDatabasePlan = (newPlans) => {
        setPlan(newPlans);
        var location = "users/" + username;
        const courseUpload = ref(db, location);
        FirebaseRemove(courseUpload);
        newPlans.forEach((plan) => {
            plan['key'] = null;
            FirebasePush(courseUpload, plan)
        });
        const placeholder = {"placeholder": 0};
        const placeholderRef = ref(db, location + "/placeholder");
        FirebaseSet(placeholderRef, placeholder);
    }

    const addCourseCallback = (keys, code) => {
        const newClassObj = {};
        newClassObj[code] = new Array(1).fill(0);

        var newPlan = plans.map((singlePlan) => {
            var currClass = singlePlan['plan'].filter((singleClass) => {return Object.keys(singleClass).includes(code)});
            if(keys.includes(singlePlan['key']) && currClass.length === 0) {
                //target plan
                singlePlan['plan'].push(newClassObj);
            }
            return singlePlan;
        })
        // setPlan(newPlan);
        changeDatabasePlan(newPlan);
    }

    var resultBtn;
    if (plans.length === 0) {
        resultBtn = (
            <DropdownButton title="Add to Plan" disabled={true}>
            </DropdownButton>
        );
    }
    else {
        var allKeys = [];
        var dropdownContent = plans.map((singlePlan, index) => {
            var key = singlePlan['key'];
            var keys = [];
            keys.push(key);
            allKeys.push(key);
            var name = singlePlan['name'];
            return (<Dropdown.Item as="button" key={index} onClick={()=>{addCourseCallback(keys, courseCode)}}>{name}</Dropdown.Item>)
        })

        dropdownContent.push((
            <Dropdown.Divider key={-2}/>
        ))

        dropdownContent.push((
            <Dropdown.Item as="button" key={-1} onClick={()=>{addCourseCallback(allKeys, courseCode)}}>Add to All Plans</Dropdown.Item>
        ));

        resultBtn = (
        <DropdownButton title="Add to Plan" disabled={false}>
            <Dropdown.ItemText key={-1}>Select Plan</Dropdown.ItemText>
            {dropdownContent}
        </DropdownButton>
        );
    }
    
    var table = null;
    if (currentClass !== null) {
        var courseIntro = (currentClass['info']);
        var courseName = currentClass['name'];
        var genEd = convertGenEd(currentClass['type']);
        introContent = (
            <div>
                <p>{courseName}</p>
                <p>{genEd}</p>
                <p>{courseIntro}</p>
            </div>);
        table = (<RenderInfoTable sections={currentClass['section']}/>);
    }

    var legacyUrl = "https://myplan.uw.edu/course/#/courses/" + encodeURIComponent(courseCode);

    return (
        <div className="sidebar-view">
        <div className="detail calendar">
            <section>
                <h2>
                    Course Overview
                </h2>
                {introContent}
            </section>  
            <section>
                <h2>
                    Section Information
                </h2>

                {table}
            </section>

        </div>

        <div className="calendar-options">
            <div className="calendar-titles">
                Options
            </div>
            <div className="course-chips">
                <div className="course-single">
                    <div className="course-lecture">

                    {resultBtn}

                    <a className="btn btn-outline-secondary" href={legacyUrl} target="_blank">View in Original MyPlan</a>

                    </div>
                </div>

            </div>
        </div>
    </div>
    )
}

function RenderInfoTable(props) {
    var sections = props.sections;

    if (sections.length === 0) {
        return (<p>No Information Available</p>)
    }

    const renderedSections = sections.map((section, index) => {
        return (<RenderInfoRow key={index} singleInfo={section}/>)
    })
    return (
    <table>
        <thead>
            <tr>
                <th>Section</th>
                <th>Type</th>
                <th>Day & Time</th>
                <th>Location</th>
                <th>Instructor</th>
                <th>SLN</th>  
            </tr> 
        </thead>
        <tbody>

            <tr className="spacer">
                <th scope="row"></th>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>

            {renderedSections}
        </tbody>
    </table>
    )
}

function RenderInfoRow(props) {
    const singleInfo = props.singleInfo;
    var typeStr = props.typeStr;
    var time = singleInfo.time;
    var timeDesc = ""; //Mon-1500-140Wed-1500-140
    time.forEach((timeStr) => {
        var infoAry = timeStr.split("-");
        var resultDesc = infoAry[0] + " ";
        var startTime = parseInt(infoAry[1]);
        var timeLapse = parseInt(infoAry[2]);
        var endTime = startTime;
        endTime += Math.floor(timeLapse / 60) * 100;
        endTime += timeLapse % 60;
        var startTimeStr =  startTime.toString().substring(0, 2) + ":" + startTime.toString().substring(2, 4);
        var endTimeStr =  endTime.toString().substring(0, 2) + ":" + endTime.toString().substring(2, 4);
        resultDesc += startTimeStr + " - " + endTimeStr;
        timeDesc += resultDesc + ", ";
    })
    timeDesc = timeDesc.substring(0, timeDesc.length - 2);

    return (
    <tr className={(singleInfo.type === 'Lecture' ? "detail-lec" : "detail-sec") + " " + typeStr}>
        <th scope="row">{singleInfo.name}</th>
        <td>{singleInfo.type}</td>
        <td>{timeDesc}</td>
        <td>{singleInfo.location}</td>
        <td>{singleInfo.instructor}</td>
        <td>{singleInfo.SLN}</td>
    </tr>
    )
}